module.exports = __webpack_public_path__ + "img/xasc.45a6032c.jpg";